export const USER_STATUS = {
  0: 'offline',
  1: 'online',
  2: 'away',
  3: 'busy',
  ONLINE: 'online',
  OFFLINE: 'offline'
};

export const CHAT_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video'
};

export const CALL_STATUS = {
  AUDIO_STARTED: 'jitsi_call_audio_started',
  AUDIO_MISSED: 'jitsi_call_audio_missed',
  AUDIO_ENDED: 'jitsi_call_audio_ended',
  VIDEO_STARTED: 'jitsi_call_video_started',
  VIDEO_MISSED: 'jitsi_call_video_missed',
  VIDEO_ENDED: 'jitsi_call_video_ended',
  ACCEPTED: 'jitsi_call_accepted',
  BUSY: 'jitsi_call_busy'
};
